<script setup lang="ts">
import type {PolicyDocument} from "~/composables/api";

const {data: policyImgList} = await useApiFetchPolicyDocumentList()

const curId = ref(1)
const hasActive = computed(() => curId.value !== 0)
const documentModalOpen = ref<boolean>(false)
const curOpenDocument = ref<PolicyDocument | undefined>(undefined)

function idIsActive(id: number) {
    return curId.value === id
}

function onClickPolicy(item: PolicyDocument) {
    curOpenDocument.value = item
    documentModalOpen.value = true
}
</script>

<template>
    <section class="block2">
        <div class="blockCenter">
            <div class="titleFloor">
                <div class="title">
                    人工智能+AI-智能体平台项目<span>扶持说明</span>
                </div>
            </div>

            <div class="documentBlock">
                <div class="documentList">
                    <div
                            v-for="(item,index) in policyImgList"
                            class="documentWrapper"
                            @mouseover="curId = item.id"
                            @mouseleave="curId = 0"
                            @click="onClickPolicy(item)"
                    >
                        <div class="imgWrapper"
                             :class="{active:idIsActive(item.id),cover:hasActive && !idIsActive(item.id)}">
                            <img class="img" :src="item.img" alt="政策文件">
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="curOpenDocument">
                <policy-block2-document-modal
                        :open="documentModalOpen" @on-close="documentModalOpen=false"
                        :document="curOpenDocument"
                />
            </template>

        </div>
    </section>
</template>

<style scoped lang="scss">
.block2 {
    padding-top: 188px;

    .blockCenter {
        @include glx-center-block;

        > .titleFloor {
            display: flex;
            justify-content: center;

            > .title {
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 32px;
                color: #040000;
                line-height: 1;


                > span {
                    color: rgba(255, 0, 0, 1);
                }
            }
        }

        > .documentBlock {
            margin-top: 62px;

            .documentList {
                display: flex;
                //justify-content: center;
                flex-wrap: wrap;
                width: 1200px;
                margin-left: auto;
                margin-right: auto;

                > .documentWrapper {
                    width: 370px;
                    height: 560px;
                    position: relative;
                    //@include box-shadow("0 2px 10px #909090");

                    &:not(:nth-child(3n + 1)) {
                        margin-left: 45px;
                    }

                    &:nth-child(n + 4) {
                        margin-top: 30px;
                    }


                    > .imgWrapper {
                        left: 0;
                        //right: 0;
                        width: 100%;
                        height: 100%;
                        top: 0;

                        position: absolute;
                        transition-duration: 0.3s;

                        .img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            //object-fit: fill;
                        }

                        &:hover {
                            cursor: pointer;
                        }

                        &.cover {
                            &::before {
                                content: '';
                                display: block;

                                position: absolute;
                                z-index: 10;
                                top: 0;
                                bottom: 0;
                                left: 0;
                                right: 0;
                                background-color: rgba(0, 0, 0, 0.2);
                            }
                        }


                        &.active {
                            top: -14px !important;
                        }
                    }

                }
            }
        }
    }
}
</style>